import React from "react";

interface UrlInterface {
  domain: string;
  subDomain: string;
}

export function useCustomLocation() {
  return React.useMemo(() => {
    const domain = window.location.hostname;
    const domainKeys = domain.split(".");
    let subDomain = "";
    if (domainKeys.length > 2) {
      domainKeys.splice(domainKeys.length - 2, 2);
      subDomain = domainKeys.join(".");
    }

    return {
      domain,
      subDomain,
    } as UrlInterface;
  }, []);
}
